<template>
  <v-textarea
    :label="field.label"
    :value="value"
    :disabled="field.readonly"
    v-model="$parent.entity[field.name]"
    :rules="validators()"
    :error-messages="errors"
    @change="onChange"
    :prepend-inner-icon="prependIcon"
  ></v-textarea>
</template>

<script>
import validators_mixin from "./../../mixins/validators.mixin";

export default {
  name: "TextField",
  props: ["field", "value"],
  mixins: [validators_mixin],
  computed: {
    prependIcon() {
      if (this.field.translatable) return "language";
      return "";
    }
  }
};
</script>

<style scoped></style>
